// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"25d32cfe","733":"da8cdbe1","5418":"25d32cfe","5630":"03e53b89","5796":"25d32cfe"}[chunkId] + ".chunk.css";
};